// extracted by mini-css-extract-plugin
module.exports = {"reservation_warning":"reservation_warning__3IvSw","warning_wrapper":"warning_wrapper__3uCh8"};